import React from 'react';
import { ContentTemplate, TitleHeader } from 'web-library';

import AppealSummary from '../../modules/appeal/components/@candidate/AppealSummary';

interface ReceiptProps {
  title: string;
}

const Summary = ({ title = '' }: ReceiptProps) => (
  <>
    <TitleHeader title={title} />

    <ContentTemplate type="full">
      <AppealSummary />
    </ContentTemplate>
  </>
);

export default Summary;
